const partsCache = {};

function formatter(tz) {
  const key = tz || "local";
  if (!partsCache[key]) {
    const opts = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" };
    if (tz) opts.timeZone = tz;
    partsCache[key] = new Intl.DateTimeFormat("en-GB", opts);
  }
  return partsCache[key];
}

function weekday(date, tz) {
  const opts = { weekday: "short" };
  if (tz) opts.timeZone = tz;
  return new Intl.DateTimeFormat("fr-FR", opts).format(date);
}

function parts(iso, tz) {
  const date = new Date(iso);
  const p = Object.fromEntries(formatter(tz).formatToParts(date).map((x) => [x.type, x.value]));
  return { date, day: p.day, month: p.month, year: p.year, hour: Number(p.hour) % 24, minute: p.minute };
}

export function fmtTime(iso, site) {
  if (!iso) return "—";
  const p = parts(iso, site?.timezone);
  if (site?.time_format === "12h") {
    const h = p.hour % 12 || 12;
    return `${h}:${p.minute} ${p.hour < 12 ? "AM" : "PM"}`;
  }
  return `${String(p.hour).padStart(2, "0")}:${p.minute}`;
}

export function fmtDate(iso, site) {
  if (!iso) return "—";
  const p = parts(iso, site?.timezone);
  return `${weekday(p.date, site?.timezone)} ${p.day}/${p.month}/${p.year}`;
}

export function fmtDateTime(iso, site) {
  if (!iso) return "—";
  return `${fmtDate(iso, site)} · ${fmtTime(iso, site)}`;
}

export function durationLabel(m) {
  if (!m) return "—";
  return m === 30 ? "30 min" : `${m / 60} h`;
}

export function addMinutes(iso, m) {
  return new Date(new Date(iso).getTime() + m * 60000).toISOString();
}
